import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  toRejectPayload,
  setHistoryError,
  clearHistoryError
} from './historyError';
import {
  HTTP_GETTYPE,
  MSG_TIMEOUT_REQUEST,
  STATUS_API,
  TIMEOUT_DEFAULT,
  messageToastType_const
} from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import axiosInterceptor from '../app/axiosInterceptor';
import { MESSAGE } from 'src/app/constant/message';
import { showGlobalToast } from './uiSlice';
import { _convertObjectToQuery } from '../app/utils/apiService';

export const getListDevice = AxiosAdapter.GetHttp(
  'deviceSlice/GetListDevices',
  '/devices',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDevicesForDriver = AxiosAdapter.GetHttp(
  'deviceSlice/GetListDevicesForDriver',
  '/drivers/devices',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDeviceAgency = AxiosAdapter.HttpGetById(
  'deviceSlice/GetListDevicesAgency',
  '/devices/agency',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDeviceStaff = AxiosAdapter.GetHttp(
  'deviceSlice/GetListDeviceStaff',
  '/devices/owner/staff',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const activeDevice = AxiosAdapter.HttpPost(
  'deviceSlice/activeSlice',
  '/devices/active',
  MESSAGE.ACTIVE_DEVICE_SUCCESS,
  'Kích hoạt thiết bị thất bại'
);

export const getDetailDevice = AxiosAdapter.GetHttp(
  'deviceSlice/GetDetailDevice',
  '/devices/',
  HTTP_GETTYPE.DETAIL
);

export const previewWarrantyTicket = createAsyncThunk(
  'deviceSlice/previewWarrantyTicket',
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket/preview`,
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: payload,
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      return rejectWithValue(err?.response?.data || err?.data || err);
    }
  }
);
export const previewWarrantyReplacement = createAsyncThunk(
  'deviceSlice/previewWarrantyReplacement',
  async ({ faulty_serial, replacement_serial }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-replacement/preview`,
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: { faulty_serial, replacement_serial },
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      return rejectWithValue(err?.response?.data || err?.data || err);
    }
  }
);

export const createWarrantyTicket = createAsyncThunk(
  'deviceSlice/createWarrantyTicket',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket`,
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: { ...payload, confirm: true },
        timeout: TIMEOUT_DEFAULT
      });
      const ticketCode = res?.data?.payload?.ticket_code || '';
      dispatch(
        showGlobalToast({
          message: res?.data?.message || (ticketCode ? `Tạo phiếu bảo hành ${ticketCode} thành công` : 'Tạo phiếu bảo hành thành công'),
          type: messageToastType_const.success
        })
      );
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.response?.data || err?.data || err;
      const msg = errorData?.message || 'Tạo phiếu bảo hành thất bại';
      dispatch(
        showGlobalToast({
          message: msg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);
export const executeWarrantyReplacement = createAsyncThunk(
  'deviceSlice/executeWarrantyReplacement',
  async ({ faulty_serial, replacement_serial }, { dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-replacement/execute`,
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: { faulty_serial, replacement_serial, confirm: true },
        timeout: TIMEOUT_DEFAULT
      });
      dispatch(
        showGlobalToast({
          message: res?.data?.message || 'Đổi thiết bị bảo hành thành công',
          type: messageToastType_const.success
        })
      );
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.response?.data || err?.data || err;
      const msg = errorData?.message || 'Đổi thiết bị bảo hành thất bại';
      dispatch(
        showGlobalToast({
          message: msg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);
export const assignWarrantyReplacement = createAsyncThunk(
  'deviceSlice/assignWarrantyReplacement',
  async ({ id, replacement_serial, confirm = true }, { dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket/${id}/replacement`,
        method: 'PUT',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: { replacement_serial, confirm: true },
        timeout: TIMEOUT_DEFAULT
      });
      const ticketCode = res?.data?.payload?.ticket_code || '';
      dispatch(
        showGlobalToast({
          message: res?.data?.message || (ticketCode ? `Gán thiết bị thay thế cho phiếu ${ticketCode} thành công` : 'Gán thiết bị thay thế thành công'),
          type: messageToastType_const.success
        })
      );
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.response?.data || err?.data || err;
      const msg = errorData?.message || 'Gán thiết bị thay thế thất bại';
      dispatch(
        showGlobalToast({
          message: msg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);

export const getListWarrantyTickets = createAsyncThunk(
  'deviceSlice/getListWarrantyTickets',
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket?${_convertObjectToQuery(payload)}`,
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      return rejectWithValue(err?.response?.data || err?.data || err);
    }
  }
);

export const deleteWarrantyTicket = createAsyncThunk(
  'deviceSlice/deleteWarrantyTicket',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket/${id}`,
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: TIMEOUT_DEFAULT
      });
      dispatch(
        showGlobalToast({
          message: res?.data?.message || 'Xóa phiếu bảo hành thành công',
          type: messageToastType_const.success
        })
      );
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.response?.data || err?.data || err;
      const msg = errorData?.message || 'Xóa phiếu bảo hành thất bại';
      dispatch(
        showGlobalToast({
          message: msg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);

export const updateWarrantyTicket = createAsyncThunk(
  'deviceSlice/updateWarrantyTicket',
  async ({ id, note, replacement_serial }, { dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('access-token');
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warranty-ticket/${id}`,
        method: 'PUT',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        data: { note, replacement_serial },
        timeout: TIMEOUT_DEFAULT
      });
      dispatch(
        showGlobalToast({
          message: res?.data?.message || 'Cập nhật phiếu bảo hành thành công',
          type: messageToastType_const.success
        })
      );
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.response?.data || err?.data || err;
      const msg = errorData?.message || 'Cập nhật phiếu bảo hành thất bại';
      dispatch(
        showGlobalToast({
          message: msg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);

export const getLicensePlateDevice = AxiosAdapter.GetHttp(
  'deviceSlice/getLicensePlateDevice',
  '/vehicles/license_plate/device',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createDevice = AxiosAdapter.HttpPost(
  'deviceSlice/createDevice',
  '/devices/',
  MESSAGE.CREATE_DEVICE_SUCCESS,
  'Tạo mới thiết bị thất bại'
);

export const confirmTransaction = AxiosAdapter.HttpPost(
  'deviceSlice/confirmTransaction',
  '/QRCode/confirm-transaction',
  MESSAGE.CONFIRM_DEVICE_SUCCESS,
  'Gia hạn thiết bị thất bại'
);

export const transferSeller = AxiosAdapter.HttpUpdateById(
  'deviceSlice/transferSeller',
  '/agencies/transfer/staff',
  MESSAGE.TRANSFER_STAFF_SUCCESS,
  'Chuyển thiết bị xuống nhân viên thất bại'
);

export const updateDevice = AxiosAdapter.HttpUpdateById(
  'deviceSlice/updateDevice',
  '/devices/update/info',
  MESSAGE.UPDATE_DEVICE_SUCCESS,
  'Chỉnh sửa thiết bị thất bại'
);

export const selectServicePackage = AxiosAdapter.HttpUpdateById(
  'deviceSlice/updateDevice',
  '/devices/update/package',
  MESSAGE.UPDATE_DEVICE_SUCCESS,
  'Chọn gói dịch vụ gia hạn thất bại'
);

export const updateDeviceTransfer = AxiosAdapter.HttpUpdate(
  'agencySlice/updateWarehouseTransfer',
  '/devices/assign/agency',
  MESSAGE.TRANSFER_DEVICE_SUCCESS,
  'Chuyển kho thiết bị thất bại'
);

export const updateMultiDevices = AxiosAdapter.HttpUpdate(
  'deviceSlice/updateMultiDevices',
  '/devices/assign/sales',
  MESSAGE.TRANSFER_DEVICE_SUCCESS,
  'Chuyển kho thiết bị thất bại'
);

export const importDevice = AxiosAdapter.HttpPostUploadFile(
  'deviceSlice/importDevice',
  '/devices/import',
  MESSAGE.IMPORT_DEVICE_SUCCESS,
  'Import device file thất bại'
);

export const importTransferDevice = AxiosAdapter.HttpPostUploadFile(
  'deviceSlice/importTransferDevice',
  '/devices/assign/agency/file',
  MESSAGE.IMPORT_TRANSFER_DEVICE_SUCCESS,
  MESSAGE.IMPORT_TRANSFER_DEVICE_FAIL
);

export const deleteDevices = AxiosAdapter.HttpDeleteMulti(
  'deviceSlice/deleteDevices',
  'devices',
  MESSAGE.DELETE_DEVICE_SUCCESS,
  'Xóa thiết bị thất bại'
);

export const deleteDevice = AxiosAdapter.HttpDelete(
  'deviceSlice/DeleteDevice',
  'devices',
  MESSAGE.DELETE_DEVICE_SUCCESS,
  'TXóa thiết bị thất bại'
);

export const recallDevices = AxiosAdapter.HttpUpdate(
  'deviceSlice/recallDevices',
  '/devices/recall/vehicle',
  MESSAGE.RECALL_DEVICE_SUCCESS,
  'Thu hồi thiết bị thất bại'
);

export const recallDevicesByAgency = AxiosAdapter.HttpUpdateById(
  'deviceSlice/recallDevicesByAgency',
  '/devices/recall/vehicle',
  MESSAGE.RECALL_DEVICE_SUCCESS,
  'Thu hồi thiết bị thất bại'
);
export const returnDeviceToStock = AxiosAdapter.HttpUpdateById(
  'deviceSlice/returnDeviceToStock',
  '/devices',
  'Chuyển thiết bị về lưu kho thành công',
  'Chuyển thiết bị về lưu kho thất bại'
);

export const updateDeviceDisplayName = AxiosAdapter.HttpUpdateById(
  'deviceSlice/updateDeviceDisplayName',
  '/devices/update/name',
  'Cập nhật tên hiển thị thành công',
  'Cập nhật tên hiển thị thất bại'
);

// #region get data khi search lộ trình
const requestDevicePosition = (payload, rejectWithValue) =>
  new Promise((resolve, reject) => {
    axiosInterceptor({
      url: `${process.env.REACT_APP_BACKEND_URL}/devices/${payload.id}/position?first_time=${payload.first_time}&last_time=${payload.last_time}`,
      method: 'get',
      headers: {
        'Access-Control-Allow-Origin': true,
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + localStorage.getItem('access-token'),
        timeout: TIMEOUT_DEFAULT
      }
    })
      .then(res => resolve(res.data))
      .catch(err => {
        if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
        reject(rejectWithValue(toRejectPayload(err)));
      });
  });

export const getDetailDevicePosition = createAsyncThunk(
  'deviceSlice/getDetailDevicePosition',
  (payload, { rejectWithValue }) => requestDevicePosition(payload, rejectWithValue)
);

// Same request for the fuel chart modal. Deliberately has NO reducers: the modal reads the
// dispatch result, and must not drive the playback menu's statusGetPositions / error / retry.
export const getDevicePositionForChart = createAsyncThunk(
  'deviceSlice/getDevicePositionForChart',
  (payload, { rejectWithValue }) => requestDevicePosition(payload, rejectWithValue)
);

export const getOilStatistic = createAsyncThunk(
  'deviceSlice/getOilStatistic',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/${payload.id}/statistic/oil?first_time=${payload.first_time}&last_time=${payload.last_time}`,
        method: 'get',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

export const controlSoundWarning = createAsyncThunk(
  'deviceSlice/controlSoundWarning',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/toggle/sound/warning/${payload.id}`,
        method: 'post',
        data: payload.data
      });

      dispatch(
        showGlobalToast({
          message: res?.data?.message || MESSAGE.CONTROL_SOUND_WARN_SUCCESS,
          type: messageToastType_const.success
        })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message: err?.data?.message || MESSAGE.CONTROL_SOUND_WARN_FAIL,
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err.response?.data || err);
    }
  }
);

export const controlDeviceAccStatus = createAsyncThunk(
  'deviceSlice/controlDeviceAccStatus',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/device_acc/${payload.device_id}/acc/status`,
        method: 'post',
        data: payload.data
      });

      dispatch(
        showGlobalToast({
          message: res?.data?.message || MESSAGE.CONTROL_DEVICE_ACC_SUCCESS,
          type: messageToastType_const.success
        })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message: err?.data?.message || MESSAGE.CONTROL_DEVICE_ACC_FAIL,
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err.response?.data || err);
    }
  }
);

// Cấu hình camera (thiết bị CAM, chỉ admin). BE chờ thiết bị xác nhận tối đa 3s
// nên timeout phía FE để 10s.
export const configDeviceCamera = createAsyncThunk(
  'deviceSlice/configDeviceCamera',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/config/camera/${payload.device_id}`,
        method: 'post',
        data: payload.data,
        timeout: 10000
      });

      if (res?.data?.success === false) {
        dispatch(
          showGlobalToast({
            message:
              res.data.message ||
              'Cấu hình camera thất bại, vui lòng kiểm tra lại thiết bị',
            type: messageToastType_const.error
          })
        );
        return rejectWithValue(res.data);
      }

      dispatch(
        showGlobalToast({
          message: res?.data?.message || 'Cấu hình camera thành công',
          type: messageToastType_const.success
        })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message:
            err?.data?.message ||
            'Cấu hình camera thất bại, vui lòng kiểm tra lại thiết bị',
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err?.data || err);
    }
  }
);

export const postExtendDevice = createAsyncThunk(
  'deviceSlice/postExtendDevice',
  (payload, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/extend/${payload.id}`,
        method: 'post',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        },
        data: payload.data
      })
        .then(res => {
          if (MESSAGE.EXTEND_DEVICE_SUCCESS) {
            dispatch(
              showGlobalToast({
                message: res.data.message || MESSAGE.EXTEND_DEVICE_SUCCESS,
                type: messageToastType_const.success
              })
            );
          }
          resolve(res.data);
        })
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);
          if (MESSAGE.EXTEND_DEVICE_FAIL) {
            dispatch(
              showGlobalToast({
                message:
                  err?.response?.data?.message || MESSAGE.EXTEND_DEVICE_FAIL,
                type: messageToastType_const.error
              })
            );
          }
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const maxSpeedSetting = createAsyncThunk(
  'deviceSlice/maxSpeedSetting',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/safe_zone/maximum-speed/vehicle/${payload.license_plate}`,
        method: 'put',
        data: payload.data
      });

      dispatch(
        showGlobalToast({
          message: res?.data?.message || MESSAGE.MAX_SPEED_SETTING_SUCCESS,
          type: messageToastType_const.success
        })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message:
            err?.response?.data?.message || MESSAGE.MAX_SPEED_SETTING_FAIL,
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err.response?.data || err);
    }
  }
);

export const getUsernameByPhoneNumber = createAsyncThunk(
  'deviceSlice/getUsernameByPhoneNumber',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/users/username/?phone=${payload.phoneNumber}`,
        method: 'get',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const getServicePackage = createAsyncThunk(
  'deviceSlice/getServicePackage',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/service_package/packages?device_type_id=${payload.device_type_id}&version=${payload.version}`,
        method: 'get',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const getQRCode = createAsyncThunk(
  'deviceSlice/getQRCode',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/QRCode/create/device_id/${payload.deviceId}/package_id/${payload.packageId}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const transmitActiveStatus = AxiosAdapter.HttpUpdateById(
  'deviceSlice/transmitActiveStatus',
  '/devices/toggle/transmission',
  MESSAGE.TRANSMIT_DEVICE_SUCCESS,
  MESSAGE.TRANSMIT_DEVICE_FAIL
);

export const toggleOilSensor = createAsyncThunk(
  'deviceSlice/toggleOilSensor',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/toggle/oil-sensor/${payload.id}`,
        method: 'post',
        data: payload.data,
        timeout: TIMEOUT_DEFAULT
      });

      if (res?.data?.success === false) {
        dispatch(
          showGlobalToast({
            message: res.data.message || 'Cập nhật cảm biến xăng dầu thất bại',
            type: messageToastType_const.error
          })
        );
        return rejectWithValue(res.data);
      }

      dispatch(
        showGlobalToast({
          message:
            res?.data?.message || 'Cập nhật cảm biến xăng dầu thành công',
          type: messageToastType_const.success
        })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message: err?.data?.message || 'Cập nhật cảm biến xăng dầu thất bại',
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err?.data || err);
    }
  }
);

export const transmitMultiActiveStatus = createAsyncThunk(
  'deviceSlice/transmitMultiActiveStatus',
  (payload, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/toggle/transmission/bulk`,
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        data: payload,
        timeout: TIMEOUT_DEFAULT
      })
        .then(res => {
          dispatch(
            showGlobalToast({
              message: res?.data?.message || "Xác nhận bỏ tích truyền thành công",
              type: messageToastType_const.success
            })
          );
          resolve(res.data);
        })
        .catch(err => {
          if (err?.code === 'ECONNABORTED') return reject(MSG_TIMEOUT_REQUEST);
          const errorData = err?.data || err;

          dispatch(
            showGlobalToast({
              message: err?.data?.message || MESSAGE.TRANSMIT_DEVICE_FAIL,
              type: messageToastType_const.error
            })
          );
          reject(rejectWithValue(errorData));
        });
    });
  }
);

export const updateLicensePlate = AxiosAdapter.HttpUpdateById(
  'deviceSlice/updateLicensePlate',
  '/devices/update/config',
  'Cập nhật biển số thành công',
  'Cập nhật biển số thất bại'
);

export const extendService = AxiosAdapter.HttpUpdateById(
  'deviceSlice/extendService',
  '/devices/extend/subscription',
  'Gia hạn dịch vụ thành công',
  'Gia hạn dịch vụ thất bại'
);

// #region Batch transfer theo lô serial (chỉ admin) — lookup (xem trước) + execute (thực thi)
export const warehouseTransferLookup = createAsyncThunk(
  'deviceSlice/warehouseTransferLookup',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warehouse-transfer/lookup`,
        method: 'POST',
        data: payload,
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      return rejectWithValue(err?.data || err);
    }
  }
);

export const warehouseTransferExecute = createAsyncThunk(
  'deviceSlice/warehouseTransferExecute',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/warehouse-transfer/execute`,
        method: 'POST',
        data: { ...payload, confirm: true },
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.data || err;
      dispatch(
        showGlobalToast({
          message: errorData?.message || 'Chuyển kho thiết bị thất bại',
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);

export const endUserTransferLookup = createAsyncThunk(
  'deviceSlice/endUserTransferLookup',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/end-user-transfer/lookup`,
        method: 'POST',
        data: payload,
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      return rejectWithValue(err?.data || err);
    }
  }
);

export const endUserTransferExecute = createAsyncThunk(
  'deviceSlice/endUserTransferExecute',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/devices/end-user-transfer/execute`,
        method: 'POST',
        data: { ...payload, confirm: true },
        timeout: TIMEOUT_DEFAULT
      });
      return res.data;
    } catch (err) {
      if (err?.code === 'ECONNABORTED') return rejectWithValue(MSG_TIMEOUT_REQUEST);
      const errorData = err?.data || err;
      dispatch(
        showGlobalToast({
          message: errorData?.message || 'Đổi khách hàng thất bại',
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(errorData);
    }
  }
);
// #endregion

export const deviceSlice = createSlice({
  name: 'deviceSlice',
  initialState: {
    listDevice: [],
    listPackage: [],
    listLicensePlate: [],
    totalDevice: 0,
    username: null,
    vehicleType: null,
    deviceType: null,
    imageQR: null,
    contentConfirm: null,

    statusGet: null,
    statusGetQR: null,
    statusGetPackage: null,
    statusGetPositions: null,
    historyErrors: {},
    statusCreate: null,
    statusActive: null,
    statusUpdate: null,
    statusTransfer: null,
    statusTransferSeller: null,
    statusDelete: null,
    statusDeleteMulti: null,
    statusImport: null,
    statusRecall: null,
    statusExtend: null,
    statusTransmit: null,
    statusControlSound: null,
    statusControlAcc: null,
    statusMaxSpeedSetting: null,
    statusTransferFromFile: null,
    statusUpdateLicensePlate: null,
    statusExtendService: null,

    resultImport: null,
    resultTransferImport: null,
    resultDelete: null,
    error: null,
    detailDevice: null,

    positionsDevice: null,
    numberOfItemPosition: null,
    isLoading: false,
    isTooManyRequest: false,

    timeSearching: null
  },
  reducers: {
    resetChange: state => {
      state.statusGetPositions = null;
      clearHistoryError(state, 'getDetailDevicePosition');
      state.statusMaxSpeedSetting = null;
      state.timeSearching = null;
      state.isTooManyRequest = false;
    },

    resetSearchUsernameByPhone: state => {
      state.username = '';
    },

    setTimeSearching: (state, action) => {
      state.timeSearching = action.payload;
    },

    resetResultImport: (state, action) => {
      state.resultImport = null;
      state.resultTransferImport = null;
    },

    resetListDevice: state => {
      state.listDevice = [];
      state.totalDevice = 0;
      state.statusGet = null;
    }
  },
  extraReducers: {
    // #region get device
    [getListDevice.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDevice.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDevice = action.payload.payload.devices;
      state.totalDevice = action.payload.payload.numberOfDevices;
      state.isLoading = false;
    },
    [getListDevice.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDevicesForDriver.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDevicesForDriver.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDevice = action.payload.payload.devices;
      state.totalDevice = action.payload.payload.numberOfDevices;
      state.isLoading = false;
    },
    [getListDevicesForDriver.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDeviceAgency.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDeviceAgency.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDevice = action.payload.payload.devices;
      state.totalDevice = action.payload.payload.numberOfDevices;
      state.isLoading = false;
    },
    [getListDeviceAgency.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDeviceStaff.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDeviceStaff.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDevice = action.payload.payload.devices;
      state.totalDevice = action.payload.payload.numberOfDevices;
      state.isLoading = false;
    },
    [getListDeviceStaff.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    // #region get username by phone number
    [getUsernameByPhoneNumber.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getUsernameByPhoneNumber.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.username = action.payload.payload;
      state.isLoading = false;
    },
    [getUsernameByPhoneNumber.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.isLoading = false;
    },
    // #region get license plate device
    [getLicensePlateDevice.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getLicensePlateDevice.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listLicensePlate = action.payload.payload.result.result;
      state.isLoading = false;
    },
    [getLicensePlateDevice.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.isLoading = false;
    },

    [getDetailDevice.pending]: state => {
      state.isLoading = true;
      state.statusGet = STATUS_API.PENDING;
      state.detailDevice = null;
    },
    [getDetailDevice.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.statusGet = STATUS_API.SUCCESS;
      state.detailDevice = action.payload.payload.device;
    },
    [getDetailDevice.rejected]: (state, action) => {
      state.isLoading = false;
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    // #region get device position
    [getDetailDevicePosition.pending]: state => {
      clearHistoryError(state, 'getDetailDevicePosition');
      state.isLoading = true;
      state.isTooManyRequest = false;
      state.statusGetPositions = STATUS_API.PENDING;
      state.positionsDevice = null;
    },
    [getDetailDevicePosition.fulfilled]: (state, action) => {
      clearHistoryError(state, 'getDetailDevicePosition');
      state.statusGetPositions = STATUS_API.SUCCESS;
      state.positionsDevice = action.payload.payload.path;
      state.vehicleType = action.payload.payload.vehicle_type;
      state.deviceType = action.payload.payload.device_type;
      state.numberOfItemPosition = action.payload.payload.number_of_items;
      state.isLoading = false;
      state.isTooManyRequest = false;
    },
    [getDetailDevicePosition.rejected]: (state, action) => {
      state.statusGetPositions = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      setHistoryError(state, 'getDetailDevicePosition', action);
      state.isLoading = false;
      // Only a real 429 is "too many requests"; any other failure used to be
      // mislabelled as such.
      state.isTooManyRequest = action.payload?.status === 429;
    },

    // #region get service package
    [getServicePackage.pending]: state => {
      state.isLoading = true;
      state.statusGetPackage = STATUS_API.PENDING;
    },
    [getServicePackage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.statusGetPackage = STATUS_API.SUCCESS;
      state.listPackage = action.payload.payload.result;
    },
    [getServicePackage.rejected]: (state, action) => {
      state.isLoading = false;
      state.statusGetPackage = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    // #region get image QR code
    [getQRCode.pending]: state => {
      state.isLoading = true;
      state.statusGetQR = STATUS_API.PENDING;
    },
    [getQRCode.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.statusGetQR = STATUS_API.SUCCESS;
      state.imageQR = action.payload.payload.result.qrCodeBase64;
      state.contentConfirm = action.payload.payload.result.description;
    },
    [getQRCode.rejected]: (state, action) => {
      state.isLoading = false;
      state.statusGetQR = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region create device
    [createDevice.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createDevice.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createDevice.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region active device
    [activeDevice.pending]: state => {
      state.statusActive = STATUS_API.PENDING;
    },
    [activeDevice.fulfilled]: (state, action) => {
      state.statusActive = STATUS_API.SUCCESS;
    },
    [activeDevice.rejected]: (state, action) => {
      state.statusActive = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region recall device
    [recallDevicesByAgency.pending]: state => {
      state.statusRecall = STATUS_API.PENDING;
    },
    [recallDevicesByAgency.fulfilled]: (state, action) => {
      state.statusRecall = STATUS_API.SUCCESS;
    },
    [recallDevicesByAgency.rejected]: (state, action) => {
      state.statusRecall = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region recall device
    [recallDevices.pending]: state => {
      state.statusRecall = STATUS_API.PENDING;
    },
    [recallDevices.fulfilled]: (state, action) => {
      state.statusRecall = STATUS_API.SUCCESS;
    },
    [recallDevices.rejected]: (state, action) => {
      state.statusRecall = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region extend device
    [postExtendDevice.pending]: state => {
      state.statusExtend = STATUS_API.PENDING;
    },
    [postExtendDevice.fulfilled]: (state, action) => {
      state.statusExtend = STATUS_API.SUCCESS;
    },
    [postExtendDevice.rejected]: (state, action) => {
      state.statusExtend = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region confirm transaction
    [confirmTransaction.pending]: state => {
      state.statusExtend = STATUS_API.PENDING;
    },
    [confirmTransaction.fulfilled]: (state, action) => {
      state.statusExtend = STATUS_API.SUCCESS;
    },
    [confirmTransaction.rejected]: (state, action) => {
      state.statusExtend = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region delete device
    [deleteDevice.pending]: state => {
      state.statusDelete = STATUS_API.PENDING;
    },
    [deleteDevice.fulfilled]: (state, action) => {
      state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteDevice.rejected]: (state, action) => {
      state.statusDelete = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [updateDevice.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateDevice.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateDevice.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    //#region Transfer device
    [updateDeviceTransfer.pending]: state => {
      state.statusTransfer = STATUS_API.PENDING;
    },
    [updateDeviceTransfer.fulfilled]: (state, action) => {
      state.statusTransfer = STATUS_API.SUCCESS;
    },
    [updateDeviceTransfer.rejected]: (state, action) => {
      state.statusTransfer = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    //#region Transfer Staff
    [transferSeller.pending]: state => {
      state.statusTransferSeller = STATUS_API.PENDING;
    },
    [transferSeller.fulfilled]: (state, action) => {
      state.statusTransferSeller = STATUS_API.SUCCESS;
    },
    [transferSeller.rejected]: (state, action) => {
      state.statusTransferSeller = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [importDevice.pending]: state => {
      state.statusImport = STATUS_API.PENDING;
    },
    [importDevice.fulfilled]: (state, action) => {
      state.statusImport = STATUS_API.SUCCESS;
      state.resultImport = action.payload;
    },
    [importDevice.rejected]: (state, action) => {
      state.statusImport = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [deleteDevices.pending]: state => {
      state.statusDeleteMulti = STATUS_API.PENDING;
    },
    [deleteDevices.fulfilled]: (state, action) => {
      state.statusDeleteMulti = STATUS_API.SUCCESS;
      state.resultDelete = action.payload.payload;
    },
    [deleteDevices.rejected]: (state, action) => {
      state.statusDeleteMulti = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [updateMultiDevices.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateMultiDevices.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateMultiDevices.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [updateDeviceDisplayName.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    //#region Add Display_Name
    [updateDeviceDisplayName.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },

    [updateDeviceDisplayName.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [transmitActiveStatus.pending]: state => {
      state.statusTransmit = STATUS_API.PENDING;
    },

    [transmitActiveStatus.fulfilled]: (state, action) => {
      state.statusTransmit = STATUS_API.SUCCESS;
    },

    [transmitActiveStatus.rejected]: (state, action) => {
      state.statusTransmit = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    [transmitMultiActiveStatus.pending]: state => {
      state.statusTransmit = STATUS_API.PENDING;
    },

    [transmitMultiActiveStatus.fulfilled]: state => {
      state.statusTransmit = STATUS_API.SUCCESS;
    },

    [transmitMultiActiveStatus.rejected]: (state, action) => {
      state.statusTransmit = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },

    // Control Sound Warning
    [controlSoundWarning.pending]: state => {
      state.statusControlSound = STATUS_API.PENDING;
    },

    [controlSoundWarning.fulfilled]: (state, action) => {
      state.statusControlSound = STATUS_API.SUCCESS;
    },

    [controlSoundWarning.rejected]: (state, action) => {
      state.statusControlSound = STATUS_API.ERROR;
      state.error = action.payload?.message || MESSAGE.CONTROL_SOUND_WARN_FAIL;
    },

    // Control device ACC
    [controlDeviceAccStatus.pending]: state => {
      state.statusControlAcc = STATUS_API.PENDING;
    },

    [controlDeviceAccStatus.fulfilled]: state => {
      state.statusControlAcc = STATUS_API.SUCCESS;
    },

    [controlDeviceAccStatus.rejected]: (state, action) => {
      state.statusControlAcc = STATUS_API.ERROR;
      state.error = action.payload?.message || MESSAGE.CONTROL_DEVICE_ACC_FAIL;
    },

    // Max speed setting
    [maxSpeedSetting.pending]: state => {
      state.statusMaxSpeedSetting = STATUS_API.PENDING;
    },

    [maxSpeedSetting.fulfilled]: state => {
      state.statusMaxSpeedSetting = STATUS_API.SUCCESS;
    },

    [maxSpeedSetting.rejected]: (state, action) => {
      state.statusMaxSpeedSetting = STATUS_API.ERROR;
      state.error = action.payload?.message || MESSAGE.MAX_SPEED_SETTING_FAIL;
    },

    // Transfer device from file
    [importTransferDevice.pending]: state => {
      state.statusTransferFromFile = STATUS_API.PENDING;
    },

    [importTransferDevice.fulfilled]: (state, action) => {
      state.statusTransferFromFile = STATUS_API.SUCCESS;
      state.resultTransferImport = action.payload;
    },

    [importTransferDevice.rejected]: (state, action) => {
      state.statusTransferFromFile = STATUS_API.ERROR;
      state.error = action.payload?.message || MESSAGE.CONTROL_SOUND_WARN_FAIL;
    },

    // Update license plate
    [updateLicensePlate.pending]: state => {
      state.statusUpdateLicensePlate = STATUS_API.PENDING;
    },

    [updateLicensePlate.fulfilled]: (state, action) => {
      state.statusUpdateLicensePlate = STATUS_API.SUCCESS;
    },

    [updateLicensePlate.rejected]: (state, action) => {
      state.statusUpdateLicensePlate = STATUS_API.ERROR;
      state.error = action.payload?.message || MESSAGE.CONTROL_SOUND_WARN_FAIL;
    },

    // Extend service
    [extendService.pending]: state => {
      state.statusextendService = STATUS_API.PENDING;
    },

    [extendService.fulfilled]: (state, action) => {
      state.statusextendService = STATUS_API.SUCCESS;
    },

    [extendService.rejected]: (state, action) => {
      state.statusextendService = STATUS_API.ERROR;
      state.error = action.payload?.message;
    }
  }
});
export const {
  resetChange,
  setActiveStep,
  setTimeSearching,
  setObjectCreating,
  resetSearchUsernameByPhone,
  resetResultImport,
  resetListDevice
} = deviceSlice.actions;

export default deviceSlice.reducer;
